import { IAddressComponent, AddressComponentType } from '.'

export const extendBoundsByOffset = (bounds: any, offset: number) => {
  const center = bounds.getCenter()
  // northEast
  bounds.extend(
    //@ts-ignore
    new window.google.maps.LatLng(center.lat() + offset, center.lng() + offset)
  )
  // soutWest
  bounds.extend(
    //@ts-ignore
    new window.google.maps.LatLng(center.lat() - offset, center.lng() - offset)
  )
}

export const getTypeFromGeocodeAPI = (
  addrComponents: IAddressComponent[],
  types: AddressComponentType[]
): IAddressComponent | undefined =>
  addrComponents?.find(({ types: addrTypes }) =>
    addrTypes?.some((type: string) =>
      types.includes(type as AddressComponentType)
    )
  )
